import React, {useEffect, useState} from "react";
import { VoucherIcon } from "../../../../helper/HwIconExcursion";
import {getUserToken} from "../../../../helper/commonFunction";
import {ApiCall} from "../../../../helper/axios";
import {ChevronDownIcon, ChevronUpIcon} from "../../../../helper/HwIcon";
import axios from "axios";

const POLL_INTERVAL_MS = 2500;
const POLL_MAX_ATTEMPTS = 30;

export const Tickets = ({ bookingDetails, pdfLoading }) => {
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [downloading, setDownloading] = useState(0);
    const [makeBtnDisable, setMakebtnDisable] = useState({
        withContact: false,
        withoutContact: false,
    });
    const [extraEmailSectionShow, setExtraEmailSectionShow] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    const [emails, setEmails] = useState();
    const [btnLoader, setBtnLoader] = useState(false);
    const [withoutBtnLoader, setWithoutBtnLoader] = useState(false);
    const [sendExtraBtn, setSendExtraBtn] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false);
    const userToken = getUserToken();
    const title =
        bookingDetails?.isEmaar || bookingDetails?.tickets?.length <= 1
            ? "Download Ticket"
            : "Download tickets";

    useEffect(() => {
        if (bookingDetails?.tickets?.length > 10) {
            setExtraEmailSectionShow(false);
        }
    }, []);

    const openDownloadUrl = (url, fileName) => {
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName || "";
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };
    const downloadTicketAxios = async (bookingId,withcontact) => {
        const res = await axios.get(`${process.env.client_apiEndpoint}/excursion-tickets/${bookingId}/${withcontact}`, {
            headers: {
                "Authorization": getUserToken(),
            },
        });
        if(res?.data?.data?.downloadUrl){
            window.open(res?.data?.data?.downloadUrl)
        } else {
            setErrorMsg("Something went wrong while generating tickets.")
            return;
        }
        // const url = window.URL.createObjectURL(res?.data?.downloadUrl);
        // const a = document.createElement("a");
        // a.href = url;
        // a.download = `${bookingDetails?.booking_ref_no} - ${bookingDetails?.variation_title}.pdf`;
        // a.click();
        // window.URL.revokeObjectURL(url);
    };

    const handleStreamEvent = async (rawEvent) => {
        const lines = rawEvent.split("\n");
        let eventType = "message";
        let data = "";
      
        for (const line of lines) {
          if (line.startsWith("event:")) {
            eventType = line.replace("event:", "").trim();
          }
          if (line.startsWith("data:")) {
            data += line.replace("data:", "").trim();
          }
        }
      
        const parsedData = data ? JSON.parse(data) : {};
      
        switch (eventType) {
          case "queued":
            setShowMessage(
                `Your ticket is being prepared. 
            Estimated time: ${parsedData.estimatedSeconds} seconds. 
            You may wait here or download later from Booking History.`
              );
            setDownloadLoading(true);
            break;
          case "status":
            if (parsedData.ticket_pdf_status === "pending") {
              setShowMessage("Your tickets are being prepared...");
            }
            break;
          case "generating":
            setShowMessage("Generating your ticket PDF...");
            break;
          case "ready":
                setShowMessage("Your ticket is ready. Downloading...");
                setDownloadLoading(false);
                await downloadTicketAxios(
                    bookingDetails?.id,
                    parsedData?.withcontact
                );
                setShowMessage("")
                break;
          case "failed":
            setShowMessage(
              parsedData.ticket_pdf_error || "Failed to generate tickets."
            );
            setDownloadLoading(false);
            break;
          case "overload":
            setShowMessage(
              parsedData.message || "High traffic. Please try again shortly."
            );
            setDownloadLoading(false);
            break;
      
          default:
            break;
        }
      };
      
      

    const downloadTicketFn = async (withcontact = false) => {
        if (!bookingDetails?.id) return;
        setShowMessage("Your tickets are being generated. Please wait a moment.");
        setDownloadLoading(true);
        try{
            const payload = {
                userToken: getUserToken(),
                bid: bookingDetails?.id,
                withcontact: withcontact,
                travel_date: bookingDetails?.travel_date,
            };
            const response = await fetch(
                `${process.env.client_apiEndpoint}/excursion-tickets`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: getUserToken(),
                  },
                  body: JSON.stringify(payload),
                }
              );
            
              if (!response.ok || !response.body) {
                throw new Error("Failed to connect to stream");
              }
              const reader = response.body.getReader();
              const decoder = new TextDecoder("utf-8");
              let buffer = "";
              while (true) {
                const { value, done } = await reader.read();
                if (done) break;
                buffer += decoder.decode(value, { stream: true });
                const events = buffer.split("\n\n");
                buffer = events.pop();
                for (const rawEvent of events) {
                  handleStreamEvent(rawEvent);
                }
              }
        } catch (error) {
            console.error(error);
        } finally {
            setDownloadLoading(false);
        }
    };

    const downLoadAllTicketFn = async (downloadTicket, withContact) => {
        if (bookingDetails?.tickets?.length > 10) {
            if (withContact && bookingDetails?.download_ticket_url) {
                openDownloadUrl(bookingDetails.download_ticket_url);
            } else if (!withContact && bookingDetails?.download_ticket_url_wc) {
                openDownloadUrl(bookingDetails.download_ticket_url_wc);
            } else {
                setMakebtnDisable({ withContact: true, withoutContact: true });
                setTimeout(() => {
                    setMakebtnDisable({ withContact: false, withoutContact: false });
                }, 20000);
                setShowMessage("");
                if (withContact) setBtnLoader(true);
                else setWithoutBtnLoader(true);
                await downloadTicketFn(withContact);
                setBtnLoader(false);
                setWithoutBtnLoader(false);
            }
        } else {
            if (!downloadTicket) return;
            openDownloadUrl(downloadTicket);
        }
    };


    const sendExtraEmailFn = async () => {
        if (!emails || emails.trim() === "") {
            setErrorMsg("Please enter at least one email address.");
            return;
        }
        setMakebtnDisable({...makeBtnDisable,sendMail : true})
        const emailList = emails.split(",")
            .map(e => e.trim())
            .filter(e => e !== "");

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        const invalidEmails = emailList.filter(e => !emailRegex.test(e));

        if (invalidEmails.length > 0) {
            setErrorMsg(`Invalid email: ${invalidEmails.join(", ")}`);
            return;
        }

        setSendExtraBtn(true);

        const details = await ApiCall(
            "POST",
            `downloadTicketsPdf`,
            {
                userToken: userToken,
                bookingId: bookingDetails?.id,
                withcontact: false,
                emails: emailList,
                extra_email: true
            },
            {},
            "excursion"
        );

        setShowMessage(details?.data);
        setSendExtraBtn(false);
        setEmails('')
    }

    return (
        <div className="hw-after--bookingWidget tickets">
            <div className="d-flex justify-between align-items-center hw-gapy10">
                <h4 className="h4 mb-0 hw-blue">Tickets</h4>
                {/* <span className="hw-primary">
          <VoucherIcon />
        </span> */}
            </div>
            <div className="hw-tk--dlRow">
            <div onClick={() => {  setDownloading(0); downloadTicketFn(true);}}>
                <button
                    disabled={downloadLoading}
                    className={`hw-btn hw-btn--primary w-100 ${downloadLoading && downloadLoading === 0 && "hw-btn-disabled"}`}
                >
                    {downloadLoading && downloading === 0 ? (
                        <span
                            style={{ minWidth: "2.8rem", minHeight: "2.8rem" }}
                            className="hw-main--loaderCommon"
                        />
                    ) : 'With Contact'
                    }
                </button>
            </div>
            <div onClick={() => {setDownloading(1); downloadTicketFn(false);}}>
                <button
                    disabled={downloadLoading}
                    className={`hw-btn hw-btn--primaryOutline w-100`}
                >
                    {downloadLoading && downloading === 1 ? (
                        <span
                            style={{ minWidth: "2.8rem", minHeight: "2.8rem" }}
                            className="hw-main--loaderCommon"
                        />
                    ) : 'Without Contact'}
                </button>
            </div>
            </div>
            {showMessage ? <span className="hw-text14 hw-primary hw-fontWeight--500">{showMessage}</span> : ''}
            {errorMsg ? <span className="hw-text14  hw-red hw-grayk600 hw-fontWeight--500">{errorMsg}</span> : ''}
            <span className="hw-text14 hw-grayk600 hw-fontWeight--500"><b>Note:</b> Tickets will always be available on the Booking History page, and you can download them anytime.</span>
            {extraEmailSectionShow ?
                <>
                    <div className="hw-passenger--fareSummary__tbodyTR" style={{flexDirection:"column",gap:"1rem",borderTop:"1px solid var(--hw-gray-600)",paddingTop:"1.6rem"}}>
                        <span style={{cursor:"pointer"}}  className="hw-black hw-text18 hw-fontBold d-flex align-item-center">Send tickets to additional emails (optional)</span>
                        <span className="hw-text14  hw-grayk600 hw-fontWeight--500">If you want to send this ticket to any other email address, you can add multiple emails separated by commas and click the Send button.</span>
                        <div className="d-flex d-flex-column hw-gapx10">
                            <input
                                type="text"
                                value={emails}
                                placeholder="abc@gmail.com, test@gmail.com"
                                className="hw-form--input markup-price"
                                onChange={(event) => {
                                    setEmails(event?.target?.value)
                                }}
                            />
                            {errorMsg ? <span className="hw-text14  hw-red hw-grayk600 hw-fontWeight--500">{errorMsg}</span> : ''}
                            <button
                                onClick={()=>{
                                    setErrorMsg("")
                                    sendExtraEmailFn();
                                }}
                                className={`hw-btn hw-btn--primary w-100`}
                            >
                                {sendExtraBtn ? <span style={{minWidth: '2.8rem', minHeight: "2.8rem"}}
                                                      className='hw-main--loaderCommon'/> : 'Send'}
                            </button>
                        </div>
                    </div>

                </>
                : null}
        </div>
    );
};
